import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl, setFormDataV2 } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  constructor(private http: HttpClient) { }

  getRoutes(queryParams) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.ROUTE_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  saveRoutes(id, payload) {
    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.ROUTE_URL + `/${id}`, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.ROUTE_URL, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  cancelRoute(id, queryParams) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.delete<any>(urls.BASE_URL + urls.ROUTE_URL + `/${id}`, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  getRoutesbyId(id) {
    return this.http.get<any>(urls.BASE_URL + urls.ROUTE_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  bulkUpdate(payload) {
    return this.http.put<any>(urls.BASE_URL + urls.ROUTE_URL + '/bulk', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getRoutesList(date) {
    let params = new HttpParams();
    params = params.append('scheduleTime', date);
    return this.http.get<any>(urls.BASE_URL + urls.ROUTE_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

}
